// < Less than
// > Greater than
// = Equal to
// != or <> Not equal to
// <= Less than or equal to
// >= Greater than or equal to
// LIKE Wildcard operator for string-based fields
// ILIKE Wildcard operator for string-based fields

export enum KnockOperator {
  LessThan = '<',
  GreaterThan = '>',
  EqualTo = '=',
  NotEqualTo = '<>',
  LessThanOrEqualTo = '<=',
  GreatThanOrEqualTo = '>=',
  StringWildcard = 'ILIKE',
  StartsWith = '^',
  Any = 'ANY'
}

export enum KnockTypes {
  String = 'string',
  Boolean = 'bool',
  StringArray = 'DbStringSlice',
  EnumArray = 'SliceOfEnum',
  EnumCountryCode = 'EnumCountryCode',
  EnumProposalStatus = 'EnumProposalStatus',
  Date = 'Date',
  DateTime = 'DateTime',
  Number = 'int',
  Decimal = 'Decimal',
  Registration = 'Registration',
  Money = 'Money',
  HexColour = 'HexColour',
  PhoneNumber = 'PhoneNumber',
  EmailAddress = 'EmailAddress',
  Image = 'Image',
  RawMessage = 'RawMessage',
  LambdaError = 'LambdaError',
  ShopID = 'ID',
  VIN = 'VIN'
}

export enum KnockOrderByOptions {
  Ascending = 'ASC',
  Descending = 'DESC',
  None = ''
}

export const defaultKnockOperators: { [K in KnockTypes]: KnockOperator } = {
  [KnockTypes.String]: KnockOperator.StringWildcard,
  [KnockTypes.Registration]: KnockOperator.StringWildcard,
  [KnockTypes.ShopID]: KnockOperator.StringWildcard,
  [KnockTypes.Boolean]: KnockOperator.EqualTo,
  [KnockTypes.StringArray]: KnockOperator.EqualTo,
  [KnockTypes.EnumArray]: KnockOperator.Any,
  [KnockTypes.EnumCountryCode]: KnockOperator.EqualTo,
  [KnockTypes.EnumProposalStatus]: KnockOperator.EqualTo,
  [KnockTypes.Date]: KnockOperator.EqualTo,
  [KnockTypes.DateTime]: KnockOperator.EqualTo,
  [KnockTypes.Number]: KnockOperator.EqualTo,
  [KnockTypes.Decimal]: KnockOperator.EqualTo,
  [KnockTypes.Money]: KnockOperator.EqualTo,
  [KnockTypes.HexColour]: KnockOperator.EqualTo,
  [KnockTypes.EmailAddress]: KnockOperator.StringWildcard,
  [KnockTypes.PhoneNumber]: KnockOperator.StringWildcard,
  [KnockTypes.Image]: KnockOperator.EqualTo,
  [KnockTypes.RawMessage]: KnockOperator.EqualTo,
  [KnockTypes.LambdaError]: KnockOperator.EqualTo,
  [KnockTypes.VIN]: KnockOperator.StringWildcard
}
